import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/grailed-seller-protection';

export default function Example() {
  return (
    <>
      <Head>
        <title>Selling with confidence with Grailed Seller Protection</title>
        <meta
          name='description'
          content='Grailed assures sellers of protected sales for transactions that fully meet their criteria with its Money-Back Guarantee. Find out how to ensure your sales are covered every time.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/grailed-seller-protection' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/grailed-seller-protection' />
        <meta property='og:title' content='Selling with confidence with Grailed Seller Protection' />
        <meta
          property='og:description'
          content='Grailed assures sellers of protected sales for transactions that fully meet their criteria with its Money-Back Guarantee. Find out how to ensure your sales are covered every time.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-05-15T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-05-15T00:00:00-00:00' />
        <meta property='article:tag' content='Grailed' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
